import {
  Box,
  Divider,
  useMediaQuery,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import {
  UploadInfo,
  UploadInfoDescription,
  UploadInfoLabel,
  ViewDocumentButton,
} from "./curatorApprovalStyle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { getTextFieldStyles } from "../../../utils/FieldStyles/FieldStyles";
import { getFormattedDate } from "../../../utils/function";
import noPreviewImage from "../../../assets/no-preview.png";
import SelectedImage from "./SelectedImage";
import useThemeRender from "../../../theme/useThemeRender";
import { darkTheme } from "../../../theme/Theme";
import { useNavigate } from "react-router-dom";
import { CURATOR_PAGE_API_CONSTANT } from "../../../constant/constant";

const ArtifactManagement = ({
  artifactManagementArray,
  setArtifactManagementArray,
  downloadFile,
  contentType,
  contentId,
  pageName,
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [selectedImage, setSelectedImage] = useState([]);
  const isDarkTheme = useSelector((store) => store.theme);
  const navigate = useNavigate();

  const onDragEnd = (result, index) => {
    if (!result.destination) return;

    const reorderedImages = Array.from(selectedImage);
    const [removed] = reorderedImages.splice(result.source.index, 1);
    reorderedImages.splice(result.destination.index, 0, removed);
    setSelectedImage(reorderedImages);

    const currentStateData = {
      ...artifactManagementArray[index],
    };
    currentStateData.imageInfo = reorderedImages;
    const newArtifactManagementData = [...artifactManagementArray];
    newArtifactManagementData[index] = currentStateData;
    setArtifactManagementArray(newArtifactManagementData);
  };

  const isVideoTypes = (index, isLocal = false) =>
    contentType === "VIDEO" &&
    !isLocal &&
    pageName !== CURATOR_PAGE_API_CONSTANT.pending_approval &&
    index === 0;

  const handleDownloadNavigate = (fileId, url, contentId, index) => {
    if (isVideoTypes(index)) {
      navigate(`/video-details/${contentId}`);
    } else {
      downloadFile(fileId, url);
    }
  };

  return (
    <Box
      sx={{
        background: useThemeRender("cardBackgroundColorLayer2"),
      }}
    >
      {artifactManagementArray?.map((item, index) => (
        <Fragment key={item.versionNumber}>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "16px",
              padding: "16px",
            }}
            key={item?.uploadedDate}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: { sm: "100%", md: "360px" },
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 400,
                }}
              >
                Version number
              </Typography>

              <TextField
                id="outlined-size-small"
                size="small"
                key={`${item?.versionNumber}-text-field`}
                type="string"
                value={parseInt(item?.versionNumber)}
                disabled={true}
                width={!isMobile ? 250 : "100%"}
                autoComplete="off"
                sx={getTextFieldStyles(isMobile, isDarkTheme, darkTheme)}
                onChange={(e) => {
                  const currentStateData = {
                    ...item,
                  };
                  currentStateData.versionNumber = parseInt(e?.target.value);
                  const newArtifactManagementData = [
                    ...artifactManagementArray,
                  ];
                  newArtifactManagementData[index] = currentStateData;
                  setArtifactManagementArray(newArtifactManagementData);
                }}
                style={{
                  backgroundColor: "#F3F7FD",
                }}
              />

              {contentType !== "LINK" && (
                <Box>
                  <SelectedImage
                    label="Thumbnail"
                    images={[
                      {
                        preview: noPreviewImage,
                        name: item?.fileName,
                        id: item?.thumbnailFileId,
                      },
                    ]}
                    onDragEnd={(event, index) => onDragEnd(event, index)}
                  />
                </Box>
              )}
              <ViewDocumentButton
                variant="outlined"
                sx={{
                  marginLeft: isMobile && "auto",
                }}
                onClick={() =>
                  handleDownloadNavigate(
                    item?.fileId,
                    item?.fileUrl,
                    contentId,
                    index
                  )
                }
              >
                {isVideoTypes(index, item?.isLocal)
                  ? "Watch Video"
                  : "Open Item"}
                {/* Open item */}
                <ArrowForwardIcon sx={{ height: "16px", width: "16px" }} />
              </ViewDocumentButton>
            </Box>

            <UploadInfo sx={{ width: { sm: "100%", md: "400px" } }}>
              <UploadInfoLabel>Uploaded by</UploadInfoLabel>
              <UploadInfoDescription>{item?.uploadedBy}</UploadInfoDescription>
            </UploadInfo>

            <UploadInfo sx={{ width: { sm: "100%", md: "400px" } }}>
              <UploadInfoLabel>Upload date</UploadInfoLabel>
              <UploadInfoDescription>
                {getFormattedDate(item?.uploadedDate)}
              </UploadInfoDescription>
            </UploadInfo>
          </Box>
          {artifactManagementArray.length !== index + 1 && (
            <Divider sx={{ width: "100%", height: "20px" }} />
          )}
        </Fragment>
      ))}
    </Box>
  );
};

export default ArtifactManagement;
